import React, { useEffect, useState, useContext } from 'react';
import { connect } from 'react-redux';
import { getClients } from 'features/home/ducks/clientActions';
import { AuthContext } from 'features/auth/context/Auth';
import ClientSide from './ClientSide/ClientSide';
import MessageSide from './MessageSide/MessageSide';
import { getChatPresets } from './ducks/messagesActions';

import './messages.scss';

const queryString = require('query-string');

const Messages = ({
  getClients,
  getChatPresets,
  clients,
  channels,
  chatPresets,
  unreadChannels,
  ...props
}) => {
  const [chats, setChats] = useState(null);
  const [activeChat, setActive] = useState(null);
  const [activeChatToggle, setToggle] = useState(false);
  const { currentUser } = useContext(AuthContext);

  useEffect(() => {
    getClients();
    getChatPresets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const searchParams = queryString.parse(props.location.search);
    clients &&
      channels &&
      setChats(
        clients.map(client => {
          const channel = channels.filter(channel =>
            channel.uniqueName.includes(client.id)
          )[0];

          var chat = {
            channel: channel || {},
            client: client
          };
          if (client.id === searchParams.client) setActive(chat);
          return chat;
        })
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clients, channels]);

  const setActiveChat = clientId => {
    setActive(chats.filter(chat => chat.client.id === clientId)[0]);
    setToggle(!activeChatToggle);
  };

  return (
    <div className="messages main-wrapper">
      <div className="container">
        <div className="messages-wrapper">
          <div className="messages-sidebar">
            <ClientSide
              setActiveChat={setActiveChat}
              activeChat={activeChat}
              chats={chats}
              unreadCount={unreadChannels && unreadChannels.size}
            />
          </div>
          <div className="messages-content">
            <div className="message-side">
              {activeChat && (
                <MessageSide
                  activeChat={activeChat}
                  chatPresets={chatPresets}
                  trainer={currentUser}
                  activeChatToggle={activeChatToggle}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    clients: state.clientReducer.clients,
    channels: state.messagesReducer.channels,
    chatPresets: state.messagesReducer.chatPresets,
    unreadChannels: state.messagesReducer.unreadChannels
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClients: () => dispatch(getClients()),
    getChatPresets: () => dispatch(getChatPresets())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Messages);
